export default __webpack_public_path__ + "static/media/1.5db40a4e.png";